import { UserPermissions } from '@centecomm/portal-service';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';
import { FeatureConfiguration } from '../../Core/Types/FeatureConfiguration';
import RequestsNavigationIcon from '../../Icons/NavigationItem/Requests';

const LazyRequestsPage = React.lazy(() => import('./Pages/RequestsPage'));

const requestsConfiguration: FeatureConfiguration = {
    name: 'common:sidebar.featureRequestsTitle',
    navigationItem: {
        route: {
            text: 'common:sidebar.featureRequestsTitle',
            url: '/requests',
            Icon: RequestsNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyRequestsPage useStoredSearch={false} />
                </React.Suspense>
            ),
            tenantRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyRequestsPage useStoredSearch={false} />
                </React.Suspense>
            ),
        },
        permissions: [UserPermissions.ViewRequests],
    },
    disableFeature: [],
    checkIfEnabledViaSettings: (settings) => {
        if (settings && settings.request) {
            return settings.request.visible;
        }

        return false;
    },
};

export default requestsConfiguration;
